import type { FredrickLocalHistoryCompleteness } from 'fredrick-local-repository';

export interface MarketLibraryUrlState {
  readonly query: string;
  readonly includePartial: boolean;
  readonly includeAmbiguous: boolean;
}

export interface MarketItemUrlState {
  readonly itemKey: string | null;
  readonly completeness: FredrickLocalHistoryCompleteness;
  readonly includeAmbiguous: boolean;
}

function queryString(params: URLSearchParams): string {
  const value = params.toString();
  return value.length === 0 ? '' : `?${value}`;
}

export function marketLibraryHref(state: Partial<MarketLibraryUrlState> = {}): string {
  const params = new URLSearchParams();
  if (state.query?.trim()) params.set('q', state.query);
  if (state.includePartial) params.set('partial', '1');
  if (state.includeAmbiguous) params.set('ambiguous', '1');
  return `/library${queryString(params)}`;
}

export function marketItemHref(
  itemKey: string,
  state: Partial<Omit<MarketItemUrlState, 'itemKey'>> = {},
): string {
  const params = new URLSearchParams();
  params.set('key', itemKey);
  const completeness = state.completeness ?? 'complete';
  if (completeness !== 'complete') params.set('completeness', completeness);
  if (state.includeAmbiguous) params.set('ambiguous', '1');
  return `/library/item?${params.toString()}`;
}

export function marketSearchHref(searchId: string): string {
  const params = new URLSearchParams();
  params.set('id', searchId);
  return `/library/search?${params.toString()}`;
}

export function parseMarketLibraryState(params: URLSearchParams): MarketLibraryUrlState {
  return {
    query: params.get('q') ?? '',
    includePartial: params.get('partial') === '1',
    includeAmbiguous: params.get('ambiguous') === '1',
  };
}

export function parseMarketItemState(params: URLSearchParams): MarketItemUrlState {
  const rawCompleteness = params.get('completeness');
  const completeness: FredrickLocalHistoryCompleteness = rawCompleteness === 'all'
    || rawCompleteness === 'partial'
    ? rawCompleteness
    : 'complete';
  return {
    itemKey: params.get('key'),
    completeness,
    includeAmbiguous: params.get('ambiguous') === '1',
  };
}
